/**
 * [INPUT]: 依赖 ThemeProvider 状态、Button 与 Sun/Moon/Flame 图标
 * [OUTPUT]: 对外提供三主题显式切换控件
 * [POS]: components 的全局显示偏好入口，使用 radiogroup 暴露互斥语义
 * [PROTOCOL]: 变更时更新此头部，然后检查 AGENTS.md
 */

import { Flame, Moon, Sun } from 'lucide-react'

import { useTheme, type Theme } from '@/app/theme'
import { Button } from '@/components/ui/button'

const options: { value: Theme; label: string; icon: typeof Sun }[] = [
  { value: 'paper-white', label: '纸白', icon: Sun },
  { value: 'paper-warm', label: '暖纸', icon: Flame },
  { value: 'night-ink', label: '夜墨', icon: Moon },
]

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme()
  return (
    <div className="theme-switcher" role="radiogroup" aria-label="阅读主题">
      {options.map(({ value, label, icon: Icon }) => (
        <Button
          key={value}
          size="icon"
          variant="ghost"
          role="radio"
          aria-checked={theme === value}
          aria-label={label}
          title={label}
          className={theme === value ? 'is-selected' : undefined}
          onClick={() => setTheme(value)}
        >
          <Icon size={17} aria-hidden="true" />
        </Button>
      ))}
    </div>
  )
}
